import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import Img1 from "./img/webp/4Protection solaire architecturale UNIK SYSTEM avec brise-soleil extérieur design moderne (5).webp";
import Img2 from "./img/webp/10Claustra décoratif architectural intérieur – séparation design et protection solaire Unik System Maroc.webp";
import Img3 from "./img/webp/22Salle de conférence équipée de stores intérieurs occultants pour protection solaire et confort visuel_imgupscaler.ai_B.webp";
import Img4 from "./img/webp/18Store banne motorisé pour terrasse de villa moderne avec piscine – solution protection solaire UNIK SYSTEM.webp";
import Img5 from "./img/webp/32Façade architecturale équipée d’écrans solaires textiles pour protection thermique et design contemporain_imgupscaler..webp";

const USAcousticSection = () => {

  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: true,
    });
  }, []);

  return (
    <div className="usstretch-section">

  {/* ===== BLOC 1 ===== */}
  <div className="usstretch-row">
    <div className="usstretch-text">
      <h3 data-aos="fade-right">
        <span className="subtitle-us">US</span> FILM
      </h3><br/>
      <h5 data-aos="fade-up">Film solaire</h5>

      <p data-aos="fade-up">
        Films solaires fabriqués à partir d’un polyester évolué ultra transparent,
        conçus pour réduire la chaleur et l’éblouissement tout en conservant
        la luminosité naturelle des espaces.
      </p>

      <h6 data-aos="fade-up">Avantages :</h6>
      <ul data-aos="fade-up">
        <li>☀️ Réflexion et absorption de la chaleur solaire</li>
        <li>💡 Contrôle de l’éblouissement</li>
        <li>🛡️ Protection contre les UV</li>
        <li>❄️ Amélioration du confort thermique</li>
        <li>🛠️ Traitement anti-rayures</li>
      </ul>

      <a data-aos="fade-up" href="/film-solaire-maroc" className="learn-more-link">
        En savoir plus <span className="arrow">→</span>
      </a>
    </div>

    <div className="usstretch-image" data-aos="fade-up" data-aos-duration="3000">
      <img src={Img1} alt="US Film solaire" />
    </div>
  </div>

  {/* ===== BLOC 2 (inversé) ===== */}
  <div className="usstretch-row">
    <div className="usstretch-image" data-aos="fade-up" data-aos-duration="3000">
      <img src={Img2} alt="US Film décoratif" />
    </div>

    <div className="usstretch-text">
      <h3 data-aos="fade-up-right">
        <span className="subtitle-us">US</span> FILM
      </h3><br/>
      <h5 data-aos="fade-up">Film décoratif</h5>

      <p data-aos="fade-up">
        Films décoratifs pour vitrages permettant de personnaliser les espaces
        tout en conservant la lumière naturelle. Solution esthétique pour
        bureaux, commerces et habitations.
      </p>

      <h6 data-aos="fade-up">Avantages :</h6>
      <ul data-aos="fade-up">
        <li>🎨 Finitions décoratives variées</li>
        <li>🔒 Préservation de l’intimité</li>
        <li>💡 Passage de la lumière naturelle</li>
        <li>🛡️ Résistance à la décoloration</li>
        <li>🛠️ Traitement anti-rayures</li>
      </ul>

      <a data-aos="fade-up" href="/film-decoratif-maroc" className="learn-more-link">
        En savoir plus <span className="arrow">→</span>
      </a>
    </div>
  </div>
  {/* ===== BLOC 3 ===== */}
  <div className="usstretch-row">
    <div className="usstretch-text">
      <h3 data-aos="fade-right">
        <span className="subtitle-us">US</span> SOLAR
      </h3><br/>
      <h5 data-aos="fade-up">Store</h5>

      <p data-aos="fade-up">
        Toiles techniques pour habiller les fenêtres, baies vitrées et portes
        vitrées, permettant une gestion efficace de la lumière naturelle
        tout en améliorant le confort intérieur.
      </p>

      <h6 data-aos="fade-up">Avantages :</h6>
      <ul data-aos="fade-up">
        <li>☀️ Protection contre l’éblouissement</li>
        <li>🌑 Capacité opacifiante selon les besoins</li>
        <li>🔇 Propriétés acoustiques possibles</li>
        <li>🎨 Large choix de couleurs et textures</li>
        <li>⚡ Installation rapide et discrète</li>
      </ul>

      <a data-aos="fade-up" href="/store-interieur-maroc" className="learn-more-link">
        En savoir plus <span className="arrow">→</span>
      </a>
    </div>

    <div className="usstretch-image" data-aos="fade-up" data-aos-duration="3000">
      <img src={Img3} alt="US Solar store" />
    </div>
  </div>

  {/* ===== BLOC — US STORE BANNE ===== */}
<div className="usstretch-row ">

  <div
    className="usstretch-image"
    data-aos="fade-up"
    data-aos-duration="3000"
  >
    <img src={Img4} alt="US Store Banne façade bioclimatique" />
  </div>

  <div className="usstretch-text">
    <h3 data-aos="fade-up-right">
      <span className="subtitle-us">US</span> STORE BANNE
    </h3>
    <br />
    <h5 data-aos="fade-up">Protection solaire de façade</h5>

    <p data-aos="fade-up">
      L’habillage de façade en membrane tendue US STORE BANNE permet
      de lutter efficacement contre la surchauffe des bâtiments en
      été en bloquant le rayonnement thermique avant qu’il n’atteigne
      les surfaces vitrées.
    </p>

    <p data-aos="fade-up">
      Cette solution bioclimatique protège de l’éblouissement tout en
      conservant la lumière naturelle et la vue vers l’extérieur,
      améliorant ainsi le confort thermique et le bien-être des occupants.
    </p>

    <h6 data-aos="fade-up">Avantages :</h6>
    <ul data-aos="fade-up">
      <li>☀️ Réduction efficace de la surchauffe</li>
      <li>👁️ Protection contre l’éblouissement</li>
      <li>🌬️ Amélioration du confort thermique</li>
      <li>🏗️ Solution légère idéale en rénovation</li>
      <li>♻️ Membrane recyclable Texyloop</li>
    </ul>

    <a
      data-aos="fade-up"
      href="/store-banne-maroc"
      className="learn-more-link"
    >
      En savoir plus <span className="arrow">→</span>
    </a>
  </div>

</div>

  {/* ===== BLOC 5 ===== */}
  <div className="usstretch-row reverse">
    <div className="usstretch-image" data-aos="fade-up" data-aos-duration="3000">
      <img src={Img5} alt="US Facade architecture textile" />
    </div>
    <div className="usstretch-text">
      <h3 data-aos="fade-right">
        <span className="subtitle-us">US</span> FACADE
      </h3><br/>
      <h5 data-aos="fade-up">Habillage de façade textile</h5>

      <p data-aos="fade-up">
        Solution idéale pour habiller et rénover les façades de bâtiments
        industriels, commerciaux et publics avec des possibilités créatives
        infinies. La toile peut être imprimée pour un rendu visuel unique.
      </p>

      <h6 data-aos="fade-up">Avantages :</h6>
      <ul data-aos="fade-up">
        <li>☀️ Protection contre les rayons UV</li>
        <li>🔇 Réduction du bruit en zone urbaine</li>
        <li>🌧️ Résistance aux intempéries</li>
        <li>🎨 Impression et personnalisation</li>
        <li>🏗️ Valorisation esthétique des façades</li>
      </ul>

      <a data-aos="fade-up" href="/façade-bioclimatique-maroc" className="learn-more-link">
        En savoir plus <span className="arrow">→</span>
      </a>
    </div>

    
  </div>

  

</div>

  );
};

export default USAcousticSection;
